import React from 'react'
import Navbar from '../components/Navbar'
import UrunlerComp from '../components/Urunler_comp'
import Footer from '../components/Footer'

function Urunler() {
  return (
    <div>
        <Navbar />
        <UrunlerComp />
        <Footer />
    </div>
  )
}

export default Urunler
